/**
 * @generated SignedSource<<5eea95fc344aef76f38578e37f8ff9a2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserGroupHeader$data = {
  readonly displayName: string;
  readonly user: {
    readonly picture: AGG$URL;
  } | null | undefined;
  readonly " $fragmentType": "UserGroupHeader";
};
export type UserGroupHeader$key = {
  readonly " $data"?: UserGroupHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserGroupHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "UserGroupHeader",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "picture"
        }
      ]
    }
  ],
  "type": "JiraJqlUserFieldValue"
};

(node as any).hash = "08198f06ef3106202be1a9d0e7e7aeea";

export default node;
